export default __webpack_public_path__ + "static/media/dalengarden_thumb.5aaf9863.jpg";